import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private renderer: Renderer2;
  private scriptLoading$ = new ReplaySubject<boolean>(1);

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadApi(apiKey: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.isApiLoaded()) {
        this.scriptLoading$.next(true);
        resolve();
        return;
      }

      const script = this.renderer.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.scriptLoading$.next(true);
        resolve();
      };
      script.onerror = (error: any) => {
        reject(error);
      };

      this.renderer.appendChild(document.head, script);
    });
  }

  private isApiLoaded(): boolean {
    return typeof google !== 'undefined' && typeof google.maps !== 'undefined';
  }
}
